import { snowplow } from '../services/ConfigService'

/**
 * Features configuration
 * Feature requires the following props:
 *  - value: depending on Type
 *  - name: String
 *  - type: <boolean, integer, string>
 *  - experiment: Object<key, variant>
 */

const featuresConfig = {
  snowplowToggle: {
    value: snowplow.enabled,
    name: 'consumerhelpweb-snowplow-enabled',
    type: 'boolean',
    experiment: {
      key: null,
      variant: null
    }
  },
  onewebRollout: {
    value: false,
    name: 'oneweb-rollout',
    type: 'boolean',
    experiment: {
      key: 'WCP-242-oneweb-rollout',
      variant: null
    }
  }
}

export default featuresConfig
